import * as React from 'react';

import type { UsersDataContextValue } from './UsersDataContext.types';

import { UsersDataContext } from './UsersDataProvider';

export function useUsersData(): UsersDataContextValue {
  const context = React.useContext(UsersDataContext);

  if (!context) {
    throw new Error('useUsersData must be used within UsersDataProvider');
  }

  return context;
}
